// extracted by mini-css-extract-plugin
export var activePage = "style-mod--active-page--d3f8a";
export var activeStars = "style-mod--active-stars--c9d24";
export var clipStar = "style-mod--clip-star--857ce";
export var pLeft = "style-mod--p-left--5987a";
export var pRight = "style-mod--p-right--3cff3";
export var rContent = "style-mod--r-content--45305";
export var rDate = "style-mod--r-date--1416e";
export var rHeader = "style-mod--r-header--f5939";
export var rIcons = "style-mod--r-icons--c5253";
export var rImage = "style-mod--r-image--d653b";
export var rImagesContainer = "style-mod--r-images-container--b57ba";
export var rPages = "style-mod--r-pages--80ba6";
export var rPagination = "style-mod--r-pagination--0e6a4";
export var rTitle = "style-mod--r-title--a43b8";
export var rTopLeft = "style-mod--r-top-left--5a7c0";
export var rTopRight = "style-mod--r-top-right--61bc1";
export var rTopStars = "style-mod--r-top-stars--57871";
export var rUser = "style-mod--r-user--a8c6a";
export var rUserVerified = "style-mod--r-user-verified--836a0";
export var rVerified = "style-mod--r-verified--e6616";
export var rVotes = "style-mod--r-votes--dc8d1";
export var reviewTop = "style-mod--review-top--16844";
export var reviewUser = "style-mod--review-user--06b8b";
export var reviewsHeader = "style-mod--reviews-header--fae0d";
export var reviewsScore = "style-mod--reviews-score--17377";
export var reviewsTitle = "style-mod--reviews-title--95b97";
export var reviewsWrapper = "style-mod--reviews-wrapper--1a737";
export var starWrapper = "style-mod--star-wrapper--ac10b";
export var yReview = "style-mod--y-review--ca984";
export var yReviews = "style-mod--y-reviews--e8a26";
export var yReviewsInner = "style-mod--y-reviews-inner--b89a6";